// FTU welcome banner (US-031, US-032).
//
// Shown at the top of the inbox / campaigns landing surface immediately
// after the user completes onboarding. Composes the DS-D
// `FtuWelcomeBanner` composite — the wave's job is to wire the goal-aware
// copy + dismiss persistence + load-demo handler.

import { useState } from 'react';

import { useT } from '@barel/i18n';
import { FtuWelcomeBanner, type FtuGoal } from '@barel/ui';

import { readFtuBannerDismissed, writeFtuBannerDismissed } from '../onboarding/lib/persistence';

export interface FtuWelcomeBannerContainerProps {
  goal: FtuGoal;
  onLoadDemo: () => void;
}

export function FtuWelcomeBannerContainer({ goal, onLoadDemo }: FtuWelcomeBannerContainerProps) {
  const t = useT('ftu');
  const [dismissed, setDismissed] = useState<boolean>(() => readFtuBannerDismissed());

  if (dismissed) return null;

  const titleKey =
    goal === 'inbox'
      ? 'welcome.titleInbox'
      : goal === 'campaigns'
        ? 'welcome.titleCampaigns'
        : 'welcome.titleBoth';
  const bodyKey =
    goal === 'inbox'
      ? 'welcome.subtitleInbox'
      : goal === 'campaigns'
        ? 'welcome.subtitleCampaigns'
        : 'welcome.subtitleBoth';

  return (
    <FtuWelcomeBanner
      goal={goal}
      title={t(titleKey)}
      body={t(bodyKey)}
      loadDemoLabel={t('demo.loadButton')}
      onLoadDemo={onLoadDemo}
      onDismiss={() => {
        writeFtuBannerDismissed(true);
        setDismissed(true);
      }}
      dismissAriaLabel={t('welcome.dismiss')}
    />
  );
}
